import { useEffect, useState } from 'react';

import Button from '@mui/material/Button';

import { useRouter } from 'next/router';

import _ from 'lodash';

import { cityDomain } from '../../domain';

import { FadeInAnimation } from '../shared';

const NoResults = () => {   
    const [newCity, setNewCity] = useState(null);
    const [hidden, setHidden] = useState(false);    
    const router = useRouter();
    const city = _.get(router, 'query.city');

    useEffect(() => {
        setNewCity(city);
        getClosestCity();

        if (!hidden) {
            setHidden(true);
        }
    }, []);

    useEffect(() => {
        if (hidden) {
            setTimeout(() => {
                setHidden(false);
            }, 1000);
        }
    });

    let message =
        'Try to adjusting your search requirements or removing some filters. Alternatively, you can reset your search and start over.';
    let shallow = true;
    let buttonText = 'Start Over';

    const getClosestCity = async () => {
        const closestCity = await cityDomain.fetchClosestCity();
        setNewCity(_.get(closestCity, 'name'));
    };

    if (city === 'Nearby') {
        message = `Oh no! It looks like we don't have any buildings near you at the moment. However,
         don't fret! We regularly launch new buildings so you can always contact us to find out more.
          Alternatively, select the city nearest to you to see if there is something you'd like.`;

        shallow = false;
        buttonText = 'Nearest City';
    }

    const clearAllFilters = () => {
        router.push(
            {
                pathname: '/bookings',
                query: `city=${newCity}`,
            },
            undefined,
            { shallow },
        );
    };

    if (hidden) {
        return null;
    }

    return (
        <FadeInAnimation>
            <div className='no-results-container'>
                <h4 className='no-results-title'>No Results</h4>
                <p className='no-results-description'>{message}</p>
                <Button
                    className="outline-button-white"
                    id="no-results-button"
                    onClick={clearAllFilters}
                >
                    {buttonText}
                </Button>
            </div>
        </FadeInAnimation>
    );
};

export default NoResults;
